import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { FetchableDefaultView } from './views/PageListDetailsDefaultView';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views as BlockInteractionsViews,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { PageListDetailsEditView } from './views/PageListDetailsEditView';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { BlockType } from '../../types/api/ElementType';

type PageListDetailsProps = Views<DefaultView<FetchableDefaultView> & EditView<PageListDetailsEditView>>;

function PageListDetails({ views }: PageListDetailsProps) {
  const { t } = useTranslation(Namespace.PageListDetails);
  const { uuid, elementType } = useBlockContext();

  const editButton = createButtonObject(
    BlockInteractionsViews.EDIT,
    Icons.EDIT_PENCIL,
    `${Namespace.PageListDetails}:blockInteractions.edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <PageListDetailsEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={{
        text: t(`${Namespace.glossary}:pagelist`),
        hierarchy: 3,
        visible: true,
      }}
      views={views}
      uuid={uuid}
      elementType={elementType}
      buttons={editButton}
    >
      <FetchableDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const PageListDetailsBlock = asFetchableBlock(PageListDetails, BlockType.pagelistdetails);
export type PageListDetailsBlock = ComponentProps<typeof PageListDetailsBlock>;
